import { render, staticRenderFns } from "./bpost-verhuisservice.vue?vue&type=template&id=46abb8cc"
import script from "./bpost-verhuisservice.vue?vue&type=script&lang=js"
export * from "./bpost-verhuisservice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports